import { render, staticRenderFns } from "./trading-record.vue?vue&type=template&id=cb13a2a8&"
import script from "./trading-record.vue?vue&type=script&lang=js&"
export * from "./trading-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports